<div class="flex min-h-screen flex-col ">
    <!-- <div class="bg-white py-12 sm:py-12 flex flex-row justify-center items-center">
        <div class="mx-auto max-w-4xl px-6 max-lg:text-center lg:max-w-7xl lg:px-8">
            <img class="mx-auto h-16 w-auto" src="assets/shout_logo_blue.png" alt="SHOUT">
            <p
                class="mt-4 max-w-2xl text-pretty mx-auto t text-lg font-medium text-gray-600 max-lg:mx-auto sm:text-xl/8">
                Select a platform</p>
        </div>

    </div> -->

    <div class="relative isolate overflow-hidden bg-white">
        <div class="mx-auto px-6 pt-6 pb-12 lg:flex lg:px-8 lg:pt-8">

            <div
                class="w-full rounded-2xl ring-1 ring-inset ring-black/5 bg-[linear-gradient(115deg,var(--tw-gradient-stops))] from-[#4338CA] from-[28%] via-[#b060ff] via-[70%] to-[#ee87cb] sm:rounded-3xl shadow-lg">

                <div class="mx-auto max-w-2xl py-32 sm:py-48 lg:py-56">
                    <div class="sm:mb-8 sm:flex sm:justify-center">
                        <!-- <div
                            class="relative rounded-full px-3 py-1 text-sm/6 text-gray-600 ring-1 ring-gray-900/10 hover:ring-gray-900/20 dark:text-gray-400 dark:ring-white/10 dark:hover:ring-white/20">
                            Announcing our next round of funding. <a href="#"
                                class="font-semibold text-indigo-600 dark:text-indigo-400"><span aria-hidden="true"
                                    class="absolute inset-0"></span>Read more <span aria-hidden="true">&rarr;</span></a>
                        </div> -->

                        <img class="h-12 mb-6 mx-auto sm:h-20 w-auto" src="assets/shoutlogowhite.svg" alt="SHOUT">

                    </div>
                    <div class="text-center px-4">
                        <h1 class="text-balance text-5xl font-semibold tracking-tight text-white sm:text-7xl">
                            Connect your Socials</h1>
                        <p class="mt-8 text-pretty text-lg font-medium text-gray-200 sm:text-xl/8">
                            By connecting your social accounts, you can start using SHOUT to monetise your social media
                            presence and collaborate with global brands</p>
                        <div class="mt-10 flex items-center justify-center gap-x-6">
                            <a (click)="navigateToConnect()"
                                class="cursor-pointer rounded-md bg-white px-3.5 py-2.5 text-sm font-semibold text-indigo-600 shadow-sm hover:bg-gray-100 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white">
                              Connect Socials
                            </a>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>

    <div class="bg-gray-50 py-24 sm:py-32 dark:bg-gray-900">
        <div class="mx-auto max-w-2xl px-6 lg:max-w-7xl lg:px-8">
            <h2 class="text-center text-base/7 font-semibold text-indigo-600 dark:text-indigo-400">Collaborations, but better</h2>
            <p
                class="mx-auto mt-2 max-w-lg text-balance text-center text-4xl font-semibold tracking-tight text-gray-950 sm:text-5xl dark:text-white">
                Create more meaningful collaborations with brands</p>
            <div class="mt-10 grid gap-4 sm:mt-16 lg:grid-cols-3 lg:grid-rows-2">
                <div class="relative lg:row-span-2">
                    <div class="absolute inset-px rounded-lg bg-white lg:rounded-l-[2rem] dark:bg-gray-800"></div>
                    <div
                        class="relative flex h-full flex-col overflow-hidden rounded-[calc(theme(borderRadius.lg)+1px)] lg:rounded-l-[calc(2rem+1px)]">
                        <div class="px-8 pb-3 pt-8 sm:px-10 sm:pb-0 sm:pt-10">
                            <p
                                class="mt-2 text-lg font-medium tracking-tight text-gray-950 max-lg:text-center dark:text-white">
                                Simple Connection</p>
                            <p class="mt-2 max-w-lg text-sm/6 text-gray-600 max-lg:text-center dark:text-gray-400">Connect your social accounts with just a few clicks via Offical TikTok and Instagram APIs.</p>
                        </div>
                        <div
                            class="relative min-h-[30rem] w-full grow [container-type:inline-size] max-lg:mx-auto max-lg:max-w-sm">
                            <div
                                class="absolute inset-x-10 bottom-0 top-10 overflow-hidden rounded-t-[12cqw] border-x-[3cqw] border-t-[3cqw] border-gray-700 bg-gray-900 shadow-2xl dark:shadow-none dark:outline dark:outline-1 dark:outline-white/20">
                                <img src="../../../assets/connect_snap.PNG"
                                    alt="" class="size-full object-cover object-top" />
                            </div>
                        </div>
                    </div>
                    <div
                        class="pointer-events-none absolute inset-px rounded-lg shadow outline outline-1 outline-black/5 lg:rounded-l-[2rem] dark:outline-white/15">
                    </div>
                </div>
                <div class="relative max-lg:row-start-1">
                    <div class="absolute inset-px rounded-lg bg-white max-lg:rounded-t-[2rem] dark:bg-gray-800"></div>
                    <div
                        class="relative flex h-full flex-col overflow-hidden rounded-[calc(theme(borderRadius.lg)+1px)] max-lg:rounded-t-[calc(2rem+1px)]">
                        <div class="px-8 pt-8 sm:px-10 sm:pt-10">
                            <p
                                class="mt-2 text-lg font-medium tracking-tight text-gray-950 max-lg:text-center dark:text-white">
                                Monetise Your Channels</p>
                            <p class="mt-2 max-w-lg text-sm/6 text-gray-600 max-lg:text-center dark:text-gray-400">Collaborations with brands on TikTok and Instagram allow you to earn money from your content.</p>
                        </div>
                        <div
                            class="flex flex-1 items-center justify-center px-8 max-lg:pb-12 max-lg:pt-10 sm:px-10 lg:pb-2">
                            <img src="../../../assets/bento-earn.png"
                                alt="" class="w-full max-lg:max-w-xs dark:hidden" />
                        </div>
                    </div>
                    <div
                        class="pointer-events-none absolute inset-px rounded-lg shadow outline outline-1 outline-black/5 max-lg:rounded-t-[2rem] dark:outline-white/15">
                    </div>
                </div>
                <div class="relative max-lg:row-start-3 lg:col-start-2 lg:row-start-2">
                    <div class="absolute inset-px rounded-lg bg-white dark:bg-gray-800"></div>
                    <div
                        class="relative flex h-full flex-col overflow-hidden rounded-[calc(theme(borderRadius.lg)+1px)]">
                        <div class="px-8 pt-8 sm:px-10 sm:pt-10">
                            <p
                                class="mt-2 text-lg font-medium tracking-tight text-gray-950 max-lg:text-center dark:text-white">
                                Safety & Security</p>
                            <p class="mt-2 max-w-lg text-sm/6 text-gray-600 max-lg:text-center dark:text-gray-400">Meta and TikTok have reviewed and approved SHOUT as a safe and secure way to connect your social accounts. </p>
                        </div>
                        <div class="flex flex-1 items-center [container-type:inline-size] max-lg:py-6 lg:pb-2">
                            <img src="https://tailwindcss.com/plus-assets/img/component-images/bento-03-security.png"
                                alt="" class="h-[min(152px,40cqw)] object-cover dark:hidden" />
                            <img src="https://tailwindcss.com/plus-assets/img/component-images/dark-bento-03-security.png"
                                alt="" class="hidden h-[min(152px,40cqw)] object-cover dark:block" />
                        </div>
                    </div>
                    <div
                        class="pointer-events-none absolute inset-px rounded-lg shadow outline outline-1 outline-black/5 dark:outline-white/15">
                    </div>
                </div>
                <div class="relative lg:row-span-2">
                    <div
                        class="absolute inset-px rounded-lg bg-white max-lg:rounded-b-[2rem] lg:rounded-r-[2rem] dark:bg-gray-800">
                    </div>
                    <div
                        class="relative flex h-full flex-col overflow-hidden rounded-[calc(theme(borderRadius.lg)+1px)] max-lg:rounded-b-[calc(2rem+1px)] lg:rounded-r-[calc(2rem+1px)]">
                        <div class="px-8 pb-3 pt-8 sm:px-10 sm:pb-0 sm:pt-10">
                            <p
                                class="mt-2 text-lg font-medium tracking-tight text-gray-950 max-lg:text-center dark:text-white">
                                Simplified Collaboration</p>
                            <p class="mt-2 max-w-lg text-sm/6 text-gray-600 max-lg:text-center dark:text-gray-400">Once your socials are connected, construct your personal Media Kit and submit it to brands.</p>
                        </div>
                        <div class="relative min-h-[30rem] w-full grow">
                            <div
                                class="absolute bottom-0 left-10 right-0 top-10 overflow-hidden rounded-tl-xl bg-gray-900 shadow-2xl outline outline-1 outline-white/10 dark:bg-gray-900/60 dark:shadow-none">
                                <img src="../../../assets/media-kit.png" alt="" class="size-full object-cover object-top">
                            </div>
                        </div>
                    </div>
                    <div
                        class="pointer-events-none absolute inset-px rounded-lg shadow outline outline-1 outline-black/5 max-lg:rounded-b-[2rem] lg:rounded-r-[2rem] dark:outline-white/15">
                    </div>
                </div>
            </div>
        </div>
    </div>

</div>
